module.exports = __webpack_public_path__ + "static/media/If You Wanna.92c07b5e.jpg";